import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import FormValidation from './PressFormValidation';
import CustomInput from '../CustomInput';
import './press-form.scss';
import GoBack from '../../common/goBack/goBack';
import axios from 'axios';
import { useHistory } from 'react-router';
import SVGLoader from '../../common/SVGLoader/SVGLoader';
import DatePickerInput from '../datePicker/datePicker';
import {API_URL} from '../../../redux/services/user.service';
const PressForm = ({ data }) => {
  const history = useHistory();

  function goBack () {
    history.goBack();
  }

  const [loadSubmit, setLoadSubmit] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [success, setSuccess] = useState(false);

  const closePopup = () => {
    setOpenPopup(false);
  };

  const submitForm = (e, resetCallback) => {
    const { name, email, name_of_organization, position } = e;
    name &&
      email &&
      name_of_organization &&
      position &&
      handlePostRequest(e).then((res) => {
        if (res.status === 200) {
          resultPopup(true, resetCallback);
        } else {
          resultPopup(false);
        }
      });
  };

  const resultPopup = (result, reset) => {
    if (result) {
      setLoadSubmit(false);
      setSuccess(true);
      setOpenPopup(true);
      reset();
    } else {
      setLoadSubmit(false);
      setSuccess(false);
      setOpenPopup(true);
    }
  };

  const handlePostRequest = (data) => {
    setLoadSubmit(true);
    return axios.post(
      `${API_URL}/accreditation_form`,
      data
    );
  };

  return (
    <div className='press__form'>
      <div
        className={`donatePopup ${openPopup ? 'showPopup' : ''}`}
        id='donatePopup'
      >
        <div className='donatePopupCloseDiv' onClick={closePopup} />

        <div className='donatePopupBody'>
          <div className='donatePopupBodyCloseIcon' onClick={closePopup} />
          {success ? (
            <div className='donatePopupBodySuccess'>
              <h3>THANK YOU!</h3>
              <p>We’ve received your request. We’ll contact you via email!</p>
              <button onClick={closePopup}>Done</button>
            </div>
          ) : (
            <div className='donatePopupBodyFailure'>
              <h3>SOMETHING WENT WRONG!</h3>
              <p>Please try again!</p>
              <button onClick={closePopup}>Close</button>
            </div>
          )}
        </div>
      </div>

      <div className='press__form__header'>
        <GoBack goBack={goBack} />
        <h1 className='title'>{data?.title}</h1>
      </div>

      <div
        className='pressFormText'
        dangerouslySetInnerHTML={{ __html: data?.top_text }}
      />
      {/* <strong>Press Accreditation</strong><br/> */}
      {/* Thank you for your interest in attending and covering the InClassica International Music */}
      {/* Festival in Dubai. The Festival Press Office grants press accreditation to a limited number of */}
      {/* journalists. Accredited press receive limited complimentary screening tickets. <br/><br/> */}
      {/* The press credential application process for the 2021 Festival is currently open and close on */}
      {/* April 10th. We review every complete application submitted by the deadline. No preference */}
      {/* is given to those who apply early, but late applications will not be considered. We will notify */}
      {/* all applicants of their status at the end of September. Given the high number of applicants, */}
      {/* we are not able to accommodate everyone.<br/><br/> */}
      {/* To apply for a press accreditation, submit the form below: */}
      {/* </div> */}

      <Formik
        initialValues={{
          name: '',
          title: '',
          email: '',
          birth_date: '',
          citizenship: '',
          country: '',
          home_phone: '',
          cell: '',
          name_of_organization: '',
          position: '',
          type_of_medium: '',
          web_address: '',
          address: '',
          apt: '',
          city: '',
          state: '',
          zip: '',
          org_country: '',
          org_phone: '',
          ex: '',
          chief_editor_name: '',
          chief_editor_phone: '',
          chief_editor_email: '',
        }}
        validationSchema={FormValidation}
        validateOnChange
        onSubmit={(e, { resetForm }) => submitForm(e, resetForm)}
      >
        {() => (
          <>
            <Form className='form'>
              <CustomInput
                name='name'
                label='Name (First, Last)'
                required
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='title'
                label='Title'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='email'
                type='email'
                label='EMAIL'
                required
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <label className='form__field half'>
                <div className='form__field__label translatedLabel'>
                  Date of birth
                </div>
                <DatePickerInput name='birth_date' />
              </label>
              {/* <CustomInput */}
              {/*    name='birth_date' */}
              {/*    label='Date of birth' */}
              {/*    fieldStylesClass='form__field half' */}
              {/*    labelStylesClass='form__field__label' */}
              {/*    inputStylesClass='form__field__input' */}
              {/*    errorStylesClass='form__field__error' */}
              {/* /> */}
              <CustomInput
                name='citizenship'
                label='citizenship'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='country'
                label='COUNTRY'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='home_phone'
                label='Home Phone'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='cell'
                label='cell'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='name_of_organization'
                label='name of organization'
                required
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='position'
                label='position'
                required
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='type_of_medium'
                label='Type of medium'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='web_address'
                label='web address'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='address'
                label='address'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='apt'
                label='apt'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='city'
                label='city'
                fieldStylesClass='form__field third'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='state'
                label='state'
                fieldStylesClass='form__field third'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='zip'
                label='zip'
                fieldStylesClass='form__field third'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='org_country'
                label='Country'
                fieldStylesClass='form__field third'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='org_phone'
                label='Phone'
                fieldStylesClass='form__field third'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='ex'
                label='Ex.'
                fieldStylesClass='form__field third'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='chief_editor_name'
                label='chief editor name'
                fieldStylesClass='form__field full'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='chief_editor_phone'
                label='chief editor phone'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />
              <CustomInput
                name='chief_editor_email'
                label='chief editor email'
                fieldStylesClass='form__field half'
                labelStylesClass='form__field__label'
                inputStylesClass='form__field__input'
                errorStylesClass='form__field__error'
              />

              <div className='submitBlock'>
                <button
                  className='submit__btn'
                  disabled={loadSubmit}
                  type='submit'
                  onClick={submitForm}
                >
                  {loadSubmit ? <SVGLoader /> : <span>SUBMIT</span>}
                </button>
              </div>
            </Form>
          </>
        )}
      </Formik>

      <div
        className='pressFormText'
        dangerouslySetInnerHTML={{ __html: data?.bottom_text }}
      />
      {/*    <strong>Requirements for Media Accreditation</strong><br/> */}
      {/*    Media accreditation is strictly reserved for members of the press – print, photo, radio, TV, */}
      {/*    film, news agencies and online media – who represent a bona fide media organization. */}
      {/*    Accreditation will be granted upon presentation of valid press credentials including:<br/> */}
      {/*    <ol> */}
      {/*        <li>Completed accreditation form</li> */}
      {/*        <li>Letter of assignment on official letterhead of a media organization signed by the */}
      {/*            Publisher/Assignment Editor, Editor-in-chief or Bureau Chief, specifying the name */}
      {/*            and functional title of the journalist. Unsigned letters or e-mails will not be accepted. */}
      {/*        </li> */}
      {/*        <li>Photocopy of a valid press card/work pass</li> */}
      {/*        <li>Photocopy of passport/national ID card</li> */}
      {/*    </ol> */}
      {/*    <strong>Independent broadcast or film production companies</strong> are required to provide a letter */}
      {/*    from */}
      {/*    a broadcast organization or film distributor, which has committed to air or distribute the */}
      {/*    work or from the UN partner organization that supports the production. <br/> */}
      {/*    <strong>Print</strong> media representatives are required to submit two by lined articles within the */}
      {/*    past four */}
      {/*    months and a copy of the publication. <br/> */}
      {/*    <strong>Radio and TV</strong> media representatives are required to submit two recordings of reports */}
      {/*    within */}
      {/*    the past four months. <br/> */}
      {/*    <strong>Photographers</strong> are required to submit original tear sheets or photos with credits of the */}
      {/*    issuing organization. <br/> */}
      {/*    <strong>Online media</strong> must meet the following requirements, in addition to those above: */}
      {/*    <ul> */}
      {/*        <li>The web publication must belong to a registered company, such as a media */}
      {/*            organization, and have a */}
      {/*            specific, verifiable non-web address and a telephone number. */}
      {/*        </li> */}
      {/*        <li>The online journal requesting accreditation for its correspondent must have a */}
      {/*            substantial amount of original */}
      {/*            news content or commentary or analysis on relevant issues. */}
      {/*        </li> */}
      {/*        <li>If the web site is new, the applicant seeking accreditation must provide the latest */}
      {/*            data on the site’s visitors or other relevant material (press citations, etc.) about the */}
      {/*            outlet’s audience. The applicant must have an established record of having written */}
      {/*            extensively on relevant issues and must present copies of three recently published */}
      {/*            articles with his/her byline. */}
      {/*        </li> */}
      {/*    </ul> */}
      {/*    Freelance Journalists: Freelance journalists can only obtain accreditation for a specific event */}
      {/*    or time period. Freelance journalists, including photographers, must provide clear evidence */}
      {/*    they are on assignment from a specific news organization or publication. A valid assignment */}
      {/*    letter from that news organization, or publication, is required. <br/><br/> */}
      {/*    <strong>For any additional information, please contact:</strong><br/> */}
      {/*    <a href="mailto:marketing@eufsc.eu">marketing@eufsc.eu</a> */}
      {/* </p> */}
    </div>
  );
};

export default PressForm;
